/**
 * @author  Ben George <ben@whitepixels.com.au>
 * @date    20/09/13
 * @license http://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
 * @copyright   Copyright (c) 2013 White Pixels!
 */
//TODO: change to https://glidejs.com/docs/
//TODO: remove jquery - maybe use cake?
//Once document ready
jQuery( document ).ready(
    function($){

        var globalController = new GlobalController($);
        globalController.init();

        if( $('body').hasClass('home') ){
            var homepageController = new HomeController($);
            homepageController.init();
        };


        var materialController = new MaterialController($);
        materialController.init();

        // Lightbox
        // Initialise it
        const lightbox = GLightbox({ selector:'a[data-rel^=\'prettyPhoto\']' });

        //Decorate any lightbox galleries
        var $container = $('.lightbox.gallery');
        $container.imagesLoaded(function(){
          $container.masonry({
            itemSelector : '.gallery-item',
            columnWidth : '.gallery-item',
            gutter : '.gallery-gutter',
            percentPosition: true,
          });
        });

    }
);

// http://sparkbox.github.io/mediaCheck/
function mediaCheck(options) {
  if (typeof window.matchMedia === 'undefined' || !window.matchMedia('!').addListener) {
    throw new Error('No matchMedia support');
  }
  function mqChange(mq, options) {
    if (mq.matches) {
      if (typeof options.entry === 'function') { options.entry(mq); }
    } else {
      if (typeof options.exit === 'function') { options.exit(mq); }
      if (typeof options.both === 'function') { options.both(mq); }
    }
  }

  function createListener() {
    let mq = window.matchMedia(options.media);
    mq.addEventListener("change", () => {
      mqChange(mq, options);
    });

    window.addEventListener('orientationchange', function () {
      mq = window.matchMedia(options.media);
      mqChange(mq, options);
    }, false);

    mqChange(mq, options);
  }

  createListener();
}

/**
 * Main controller loaded and initialised on every page
 * TODO: Keep migrating code into this pattern
 * @param $
 * @returns {{}}
 * @constructor
 */
var GlobalController = function($) {
    var _public = {};
   	var _private = {};
   	var _cache = {};

    _private.mediaMenuWidth = '(min-width: 980px)';
    _private.navOpen = false;
    _private.screenReaderText = {
        expand: '<span class="screen-reader-text">expand child menu</span>',
        collapse: '<span class="screen-reader-text">collapse child menu</span>'
    }


    _cache.$carousels = $('.slick-gallery');
    _cache.$requestQuote = $('.nav-menu > .menu-item-requestaquote a');
    _cache.$menuTrigger = $('#menu-trigger');
    _cache.$outerPage = $('#outer-page');
    _cache.$innerPage = $('#page');
    _cache.$beforeAfters = $(".image-pair-wrapper img");


   	_public.init = function(){
        _private.initCarousels();
        _private.initNav();
        _private.initResponsive();
        _private.initPinterest();
        // _private.initBeforeAfters();
    };

    //Start up any carousels on the page
    _private.initCarousels = function(){
        //Animate any carousels
        _cache.$carousels.slick({
            autoplay: true,
            arrows: true,
            dots: false,
            pauseOnDotsHover: true,
            pauseOnHover: true,
            adaptiveHeight: true
        })
    };

    // //Start up any carousels on the page
    // _private.initBeforeAfters = function(){
    //     //Animate any carousels
    //     _cache.$beforeAfters.on('mouseleave',function(e){
    //         $(this).parents('.image-pair-wrapper').removeClass('hover');
    //         e.preventDefault();
    //     })
    // };

    _private.initNav = function(){

        //Setup the menu expanders
        _private.expandableMenus();
        //Setup any menu navigation's and submenu expansion/contraction events that we need
        _cache.$menuTrigger.on('click', function(e){
            _private.toggleNav();
            e.stopPropagation();
        });
        //Any tap on the main content will close the nav without accidentally navigating elsewhere
        $('#content, #content a').on('click', function(e){
            if(_private.navOpen == true){
                e.stopImmediatePropagation();
                _private.toggleNav();
                e.preventDefault();
            }
        });
        //Any left to right swipe inside the navigation will close it
        _cache.$outerPage.on('swiperight', function(e){
            if(_private.navOpen == true){
                e.stopImmediatePropagation();
                _private.toggleNav();
                e.preventDefault();
            }
        });
        // Hitting esc will close the nav as well
        $(document).keydown(function(event) {
          if (event.key === "Escape") {
            if(_private.navOpen) {
              _private.toggleNav();
            }
          }
        });
    };

    /**
     * Submenu's in the sidebar can collapse/expand
     * Based on the 2015 default theme
     */
    _private.expandableMenus = function(){
        $( '.main-navigation .menu-item-has-children > a' )
            .after( '<button class="dropdown-toggle" aria-expanded="false">' + _private.screenReaderText.expand + '</button>' );
        $( '.main-navigation .current-menu-ancestor').addClass('expanded');
        $( '.main-navigation .current-menu-ancestor > button' ).addClass( 'toggle-on' );
       	$( '.main-navigation .current-menu-ancestor > .sub-menu' ).addClass( 'toggled-on' );

        //Expansion/contraction is triggered from the arrows or from clicking on the top menu item
        var triggerElements = '.main-navigation .menu-item-has-children > a, .dropdown-toggle';
        $( triggerElements ).on("click", function( e ) {
       		var _this = $( this );
       		e.preventDefault();
       		_this.toggleClass( 'toggle-on' );
          _this.parent().toggleClass('expanded');
       		_this.nextAll( '.children, .sub-menu' ).toggleClass( 'toggled-on' );
          _this.attr( 'aria-expanded', _this.attr( 'aria-expanded' ) === 'false' ? 'true' : 'false' );
          if(_this.hasClass('dropdown-toggle')){
            _this.html( _this.html() === _private.screenReaderText.expand ? _private.screenReaderText.collapse : _private.screenReaderText.expand );
          }
       	} );
    };

    _private.toggleNav = function(){
        if(_private.navOpen == false){
            _cache.$outerPage.addClass('show-nav');
            _cache.$menuTrigger.addClass('laser-menu-close-icon');
            _private.navOpen = true;
        } else {
            _cache.$outerPage.removeClass('show-nav');
            _cache.$menuTrigger.removeClass('laser-menu-close-icon');
            _private.navOpen = false;
        }
    }

    _private.initResponsive = function(){
        //Setup any responsive resizing rules
        mediaCheck({
            media: _private.mediaMenuWidth,
            entry: function() {
                //If a user rotates a device while the menu is open we need to clean up
                if(_private.navOpen == true){
                    _private.toggleNav();
                }
            },
            exit: function() {
                //_cache.$jPM.on();
                //_cache.$requestQuote.html(_private.requestQuoteSmallText);
            }
        });
    };

    _private.initPinterest = function(){
        //Prevent pinterest hover from showing in sidebar images and banners
        $('#secondary img, .banner img').attr('data-pin-no-hover', 'true');
    };



   	return _public;
}

/* ============================================================================
   Controller: Material Pages
   ----------------------------------------------------------------------------

 ============================================================================ */
var MaterialController = function($){

	var _public = {};
	var _private = {};
	var _cache = {};

	_cache.$thumbnailWrapper = $('.thumbnail-wrapper');
    _cache.$mainImage = $('#main-image');

	_public.init = function(){
        _private.thumbnailSwap();
    };

    _private.thumbnailSwap = function(){
        //On material pages clicking on thumbnails swaps them into the main image
        _cache.$thumbnailWrapper.each( function(i){
       		$(this).on("click", { index:i }, function(event){
                event.preventDefault;

                var thumb_image = $('a', this).data('shop-image');
                var thumb_srcset = $('a img', this).attr('srcset');
                var thumb_caption = $('div.caption', this).html();
                var thumb_index = i;

                $('a',_cache.$mainImage).data('thumb_index', thumb_index);
                $('a img',_cache.$mainImage).attr('src', thumb_image);
                $('a img',_cache.$mainImage).attr('srcset', thumb_srcset);

                if(typeof thumb_caption === 'undefined'){
                    $('div.caption',_cache.$mainImage).remove();
                } else {
                    $('div.caption',_cache.$mainImage).remove();
                    $('div.caption', this).clone().appendTo(_cache.$mainImage);
                }
                return false;
       		})
       	})
    }

	return _public;
};

/* ============================================================================
   Controller: Home Page
   ----------------------------------------------------------------------------

 ============================================================================ */
var HomeController = function($){

	var _public = {};
	var _private = {};
	var _cache = {};

	_cache.$carousel = $('#gallery-1');

    _private.mediaGalleryBreakPoint = '(max-width: 375px)';

    _public.init = function(){
        _private.initCarousel();
    };

	_private.initCarousel = function(){
        //Animate any carousels
        _cache.$carousel.slick({
            autoplay: true,
            arrows: false,
            dots: true,
            pauseOnDotsHover: true,
            vertical: true
        })

    };

	return _public;
};

/* ============================================================================
   Controller: Request Quote Page
   ----------------------------------------------------------------------------

 ============================================================================ */
var QuoteController = function($){

	var _public = {};
	var _private = {};
	var _cache = {};

	_cache.$quoteform = $('#gform_wrapper_1');

    _public.init = function(){
        _private.initCarousel();
    };


	return _public;
};
/* ============================================================================
   Skip Link Focus Fix - from _s theme, see http://jimthatcher.com/skipnavold.htm
   and https://github.com/Automattic/_s/issues/543 for updates to it
   ----------------------------------------------------------------------------

 ============================================================================ */

( function() {
	var is_webkit = navigator.userAgent.toLowerCase().indexOf( 'webkit' ) > -1,
	    is_opera  = navigator.userAgent.toLowerCase().indexOf( 'opera' )  > -1,
	    is_ie     = navigator.userAgent.toLowerCase().indexOf( 'msie' )   > -1;

	if ( ( is_webkit || is_opera || is_ie ) && 'undefined' !== typeof( document.getElementById ) ) {
		var eventMethod = ( window.addEventListener ) ? 'addEventListener' : 'attachEvent';
		window[ eventMethod ]( 'hashchange', function() {
			var element = document.getElementById( location.hash.substring( 1 ) );

			if ( element ) {
				if ( ! /^(?:a|select|input|button|textarea)$/i.test( element.tagName ) )
					element.tabIndex = -1;

				element.focus();
			}
		}, false );
	}
})();